/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    top: '0px -1px 1px rgba(0, 0, 0, 0.15)',
    bottom: '0px 1px 1px rgba(0, 0, 0, 0.2)',
    productTile: {
        default: 'inset 0 -4px 0px var(--chakra-colors-stokkeGray-dark)',
        plp: `inset 0px 0px 0px 4px var(--chakra-colors-stokkeGray-mid)`
    }
}
